import type { FaireProductEntity } from "../../entity_types/product";

export const p_3vmq5mttjc: FaireProductEntity = {
  token: "p_3vmq5mttjc",
  type: "product",
  name: "Hello Lighthouse (Caldecott Medal Winner)",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl:
    "https://cdn.faire.com/fastly/b5ee937ba32b2b3bded0c12494462ad7ec93c73d52842a78ad2a98b4a203ea80.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.99,
  description:
    "A beloved picture book from two-time Caldecott Medal award-winner Sophie Blackall that transports readers to the seaside in timeless, nautical splendor! Watch the days and seasons pass as the wind blows, the fog rolls in, and icebergs drift by. Outside, there is water all around. Inside, the daily life of a lighthouse keeper and his family unfolds as the keeper boils water for tea, lights the lamp's wick, and writes every detail in his logbook.  Step back in time and through the door of this iconic lighthouse into a cozy dollhouse-like interior with the extraordinary award-winning artist Sophie Blackall.\n\nAuthor: Blackall, Sophie\nPubDate: 43200\nAge Range: Ages 4 to 8, Grades P to 3\nNumber of Pages: 48\nDimensions: 12.1 in H | 7.5 in W | 0.5 in T | 1 lb Wt\nPublisher Name: Little, Brown Books for Young Readers\nFormat Description: Hardcover Picture Book\nBISAC Category Description: Juvenile Fiction / Art",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:06.276Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
